<template>
    <div class="select_pack_wrapper">
        <a-tabs type="card" class="mt20" v-model="curTab">
            <a-tab-pane key="point_pack" tab="积分兑换" v-if="enableUsePoint">
                <package-gift-box :list="giftList" type="point" ref="point" @check="checkGift"></package-gift-box>
            </a-tab-pane>
            <a-tab-pane key="money_pack" tab="现金购买">
                <package-gift-box :list="giftList" type="money" ref="money" @check="checkGift"></package-gift-box>
            </a-tab-pane>
        </a-tabs>
        <div class="tips" v-if="tips != ''" v-html="tips"></div>
    </div>
</template>

<script>
import PackageGiftBox from '@/components/common/order/PackageGiftBox.vue'

export default {
    name: 'SelectGift',
    components: { PackageGiftBox },
    props: {
        point: {
            type: Number,
            required: true
        },
        enableUsePoint: {
            type: Boolean,
            required: true
        },
        default: {
            type: Number,
            required: true,
            default: 0
        },
        discount: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            curTab: '',
            giftList: [],
            tips: '',
            defaultGoodsId: 0
        }
    },
    watch: {
        enableUsePoint: {
            handler(val) {
                this.curTab = val ? 'point_pack' : 'money_pack';
            },
            deep: true
        },
        default: {
            handler(val) {
                this.defaultGoodsId = parseInt(val);
                this.defaultGift();
            },
            deep: true,
            immediate: true
        },
        discount: {
            handler(val) {
                if(this.giftList.length > 0){
                    for(let i = 0; i < this.giftList.length; i++){
                        let d = val.find(item => item.spec_id == this.giftList[i].spec_id);
                        
                        if(d){
                            this.giftList[i].price = parseFloat(this.giftList[i].old_price) - parseFloat(d.price);
                            this.giftList[i].point = parseFloat(this.giftList[i].old_point) - parseFloat(d.point);
                        }else{
                            this.giftList[i].price = this.giftList[i].old_price;
                            this.giftList[i].point = this.giftList[i].old_point;
                        }
                    }
                }
            },
            deep: true
        }
    },
    created() {
        this.curTab = this.enableUsePoint ? 'point_pack' : 'money_pack';
        this.getGiftList();
    },
    methods: {
        defaultGift() {
            if (this.giftList.length > 0 && this.defaultGoodsId != 0) {
                var obj = null;

                for (var i = 0; i < this.giftList.length; i++) {
                    if (this.giftList[i].id == this.defaultGoodsId) {
                        obj = this.giftList[i];
                    }
                }

                if (obj != null) {
                    this.checkGift({
                        id: obj.id,
                        num: 1,
                        type: this.enableUsePoint && obj.point <= this.point ? 'point' : 'money',
                        checked: {
                            point: this.enableUsePoint && obj.point <= this.point ? true : false,
                            money: this.enableUsePoint && obj.point <= this.point ? false : true
                        }
                    });
                }
            }
        },
        checkGift(obj) {
            if (typeof obj.id == 'undefined') {
                return false;
            }

            var gift = this.giftList;
            var tips = '';
            var weight = 0;
            var point = 0;


            if (obj.type == 'point') {
                for (var i = 0; i < gift.length; i++) {
                    gift[i].checked.point = false;
                }
            }

            for (var i = 0; i < gift.length; i++) {
                if (gift[i].id == obj.id) {
                    if (obj.type == 'point' && gift[i].point > this.point && obj.checked) {
                        this.$message.warning('积分不足，请选择其它积分包装');
                        break;
                    }

                    gift[i].checked[obj.type] = obj.checked;
                    gift[i].num = obj.num;

                    break;
                }
            }

            for (var i = 0; i < gift.length; i++) {
                if (gift[i].checked.point) {
                    // tips += gift[i].name + 'x' + gift[i].num + '，积分抵用<span>' + gift[i].point + '</span>；';
                    tips += gift[i].name + 'x 1，积分抵用<span>' + gift[i].point + '</span>；';
                    weight = parseFloat(weight) + parseFloat(gift[i].weight);
                    point = gift[i].point;
                }

                if (gift[i].checked.money) {
                    tips += gift[i].name + 'x' + gift[i].num + '，现金<span>￥' + Number(gift[i].price * gift[i].num).toFixed(2).toString() + '</span>；';
                    weight = weight + gift[i].weight * gift[i].num;
                }
            }

            this.giftList = gift;
            // this.tips = tips;
            this.$emit('changePoint', {
                point: point,
                weight: Number(weight).toFixed(3)
            })
        },
        getGiftList() {
            this.$util.api('/goods/gift', {}, res => {
                if (res.code == 10000) {
                    for (var i = 0; i < res.data.length; i++) {
                        res.data[i].old_price = res.data[i].price;
                        res.data[i].old_point = res.data[i].point;
                        res.data[i].num = 1;
                        res.data[i].checked = {
                            point: false,
                            money: false
                        };
                    }

                    this.giftList = res.data;
                    this.defaultGift();
                }
            });
        }
    },
}
</script>

<style scoped>
.tips {
    height: 38px;
    padding: 0 10px;
    background: #FAFAFA;
    font-size: 14px;
    color: #666;
    font-family: "microsoft yahei";
    line-height: 38px;
    margin-top: 20px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

>>>.tips span {
    color: #fd5902;
}

.select_pack_wrapper {
    padding: 20px;
    background: #ffffff;
}

::v-deep .ant-row-flex {
    width: 100%;
}

.title_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

h2 {
    display: inline-block;
}

.font12 {
    font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// src/components/common/order/SelectGift.vue